import { PulseSettings, PulseSettingsFactory, SettingsModule } from '@pulse/browser-settings';
import { SharedModule } from '@pulse/browser-shared';
import { PulseTracker, TrackerModule } from '@pulse/browser-tracker';
import { TrackerSharedModule } from '@pulse/browser-tracker-shared';
import { CoreModule, PulseModule, createGlobalProxy, createPulse } from '@pulse/common';
import { PulseConfigurations } from '../configuration';
import { fireOnLegacyReady } from '../legacy-on-ready';
import { fireOnReady } from '../on-ready';

function addLegacyInterfaces(
    settings: PulseSettings,
    tracker: PulseTracker,
    settingsFactory: PulseSettingsFactory,
) {
    const win = window as any;

    (win as any).dataLayer = (win as any).dataLayer || [];

    if (win.pulse) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        win.pulse!.tracker = tracker;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        win.pulse!.settings = settings;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        win.pulse!.settingsFactory = settingsFactory;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        win.pulse!._initialized = true; // TODO: add legacy interfaces (e.g. settings factory)

        fireOnLegacyReady('tracker');
        fireOnLegacyReady('settings');
    } else {
        console.warn('Pulse is not initialized');
    }
}

async function initialize() {
    if ((globalThis as any)._pulse?._initializStarted) {
        return;
    }

    (globalThis as any)._pulse = (globalThis as any)._pulse || {};

    (globalThis as any)._pulse._initializStarted = true;
    (globalThis as any).performance.mark('pulse_allInOneBundleInitStart');
    const config: Partial<PulseConfigurations> = dynamic.env['config'];
    const proxy = createGlobalProxy();
    const internals = (proxy as any).θ;
    const globalConfig = internals?.c || {};
    const mergedConfig = {
        ...(config || {}),
        ...(globalConfig || {}),
    };

    (globalThis as any).dataLayer = (globalThis as any).dataLayer || [];

    const injector = await new PulseModule()
        .import(CoreModule)
        .import(SharedModule)
        .import(TrackerSharedModule)
        .import(TrackerModule)
        .import(SettingsModule)
        .bootstrap(mergedConfig);

    const [settings, tracker, settingsFactory] = await Promise.all([
        injector.get(PulseSettings),
        injector.get(PulseTracker),
        injector.get(PulseSettingsFactory),
    ]);

    const pulse = createPulse(settings, tracker);

    addLegacyInterfaces(settings, tracker, settingsFactory);
    (globalThis as any).performance.mark('pulse_allInOneBundleInitEnd');
    (globalThis as any).performance.measure(
        'pulse_allInOneBundleInit',
        'pulse_allInOneBundleInitStart',
        'pulse_allInOneBundleInitEnd',
    );
    fireOnReady(internals, pulse);
}

initialize();
